export default "__VITE_ASSET__DkLdwbu3__"